import SkeletonBox from "./SkeletonBox";

const SkeletonHeader = ({
    titleWidth = "40%",
    subtitleWidth = "60%",
    className = "",
}: {
    titleWidth?: string;
    subtitleWidth?: string;
    className?: string;
}) => (
    <div className={`w-100 ${className}`.trim()}>
        <SkeletonBox width={titleWidth} height={16} className="mb-2" />
        <SkeletonBox width={subtitleWidth} height={12} className="mb-2" />
    </div>
);

export default SkeletonHeader;
